import React from 'react';
import { useHistory } from 'react-router-dom';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { createResourceLocatorString } from '../../util/routes';
import { getCategoryImage } from './categoryImages';
import type { Category } from './types';

interface CategoryGridProps {
  categories: Category[];
}

const CategoryGrid = ({ categories }: CategoryGridProps) => {
  const history = useHistory();
  const routeConfiguration = useRouteConfiguration();

  if (!categories?.length) return null;

  const handleCategoryClick = (categoryId: string) => {
    const path = createResourceLocatorString('CategoryPage', routeConfiguration, { categoryId }, {});
    history.push(path);
  };

  return (
    <section>
      <h2 className="text-2xl font-heading font-bold mb-6 uppercase tracking-wide">
        Shop by Category
      </h2>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4">
        {categories.map(cat => {
          const img = getCategoryImage(cat);
          return (
            <button
              key={cat.id}
              onClick={() => handleCategoryClick(cat.id)}
              className="group relative overflow-hidden rounded-xl aspect-[4/3] sm:aspect-square border border-border shadow-sm cursor-pointer block w-full text-left"
            >
              <img
                src={img}
                alt={cat.name}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent flex flex-col justify-end p-4">
                <span className="font-heading font-bold text-white text-sm sm:text-base leading-tight">
                  {cat.name}
                </span>
              </div>
            </button>
          );
        })}
      </div>
    </section>
  );
};

export default CategoryGrid;
